/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from "react";
import PropTypes from "prop-types";

const ENVELOPE_VIEWBOX_W = 20;
const ENVELOPE_VIEWBOX_H = 20;

const ENVELOPE_PATH =
  "M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3L10 7.88L2 3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V5.28L9.48 9.85C9.63202 9.93777 9.80446 9.98397 9.98 9.98397C10.1555 9.98397 10.328 9.93777 10.48 9.85L18 5.28V13Z";

/** Asset default fill from Figma (`#61677F`). */
export const ENVELOPE_ICON_DEFAULT_FILL = "#61677F";

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "aria-hidden": PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Envelope / mail (20×16 viewBox). `size` sets rendered width; height scales to aspect ratio.
 * Color via `fill` (default `currentColor`). Pass `aria-label` when meaning isn’t clear from nearby text.
 */
const EnvelopeIcon = ({
  className = "",
  size = 20,
  fill = "currentColor",
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = (size * ENVELOPE_VIEWBOX_H) / ENVELOPE_VIEWBOX_W;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${ENVELOPE_VIEWBOX_W} ${ENVELOPE_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={["ds-icon", "ds-icon--filled", className]
        .filter(Boolean)
        .join(" ")}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? "img" : undefined}
      focusable="false"
      {...props}
    >
      <path d={ENVELOPE_PATH} fill={fill} />
    </svg>
  );
};

EnvelopeIcon.propTypes = {
  ...iconPropTypes,
  /** Any valid SVG fill, e.g. `currentColor`, `ENVELOPE_ICON_DEFAULT_FILL`, `var(--ds-text-ui-subtle)`. */
  fill: PropTypes.string,
};

export { EnvelopeIcon };
export default EnvelopeIcon;
